
import { Options, prop, Vue } from "vue-class-component";
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import { PaginationV2 } from "@/domain/entities/Pagination";
import Skeleton from "@/app/ui/components/skeleton/index.vue";

class Props {
  column = prop<any[]>({
    default: () => [],
    type: Array
  });
  data = prop<any[]>({
    default: () => [],
    type: Array
  });
  orderBy = prop<string>({
    default: "",
    type: String
  });
  sortBy = prop<string>({
    default: "",
    type: String
  });
  substractHeight = prop<string>({
    default: "377"
  });
  pagination = prop<PaginationV2>({
    default: () => new PaginationV2()
  });
  loading = prop<boolean>({
    default: false
  });
}

@Options({
  components: {
    PaginationV3,
    Skeleton
  },
  emits: ["update:page", "update:sortBy", "update:orderBy", "request"]
})
export default class TableModalArea extends Vue.with(Props) {
  onSort(orderBy = "") {
    this.$emit("update:orderBy", orderBy);

    if (!this.sortBy || this.orderBy !== orderBy) {
      this.$emit("update:sortBy", "ASC");
      this.setPage(1);
      return;
    }

    if (this.sortBy === "ASC") {
      this.$emit("update:sortBy", "DESC");
      this.setPage(1);
      return;
    }

    if (this.sortBy === "DESC") {
      this.$emit("update:sortBy", "");
      this.setPage(1);
      return;
    }
  }

  setPage(page = 1) {
    this.$emit("update:page", page);
    this.$emit("request");
  }
}
